import React from "react";
import { useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import Dialog from "@mui/material/Dialog";
import { Zoom } from "@mui/material";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import { Text } from "@components";
import { ZEST_API_URL } from "@utils/config";
const APP_NAME = "Zest";

const AuthenticationModal = ({ agentLoginData, onPressClose = () => {} }) => {
  const { t } = useTranslation("common");
  const { logo } = useSelector((state) => state.headerReducer);
  const { setting } = useSelector((store) => store.settingsReducer);
  const { zestLogo } = setting?.data;

  const CustomLink = ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="golfclix noreferrer"
      style={{ color: "#33BFFF", textDecoration: "underline" }}
    >
      {children}
    </a>
  );

  const CustomParagraph = ({ children }) => (
    <p style={{ fontSize: "16px", lineHeight: "1.5" }}>{children}</p>
  );

  const CustomListItem = ({ children }) => (
    <ul className="list-inside list-disc">
      <li>{children}</li>
    </ul>
  );

  return (
    <Dialog
      open={true}
      onClose={onPressClose}
      TransitionComponent={Zoom}
      PaperProps={{
        sx: {
          margin: "0%",
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      }}
    >
      <Content>
        <div className="flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center py-4">
          <img
            src={zestLogo?.url}
            className="w-[192px] h-auto object-contain"
            alt=""
          />
          <img
            src={logo?.data?.logo?.url}
            className="w-[163px] h-auto object-contain"
            alt=""
          />
        </div>
        {agentLoginData ? (
          <div className="break-words hyphens-auto text-wrap overflow-auto ">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                li: CustomListItem,
                a: CustomLink,
                p: CustomParagraph,
              }}
              rehypePlugins={[rehypeRaw]}
            >
              {`${agentLoginData?.content}`}
            </ReactMarkdown>
          </div>
        ) : (
          <></>
        )}

        <div className="flex flex-col gap-2 md:gap-0 md:flex-row justify-between pt-6 md:pt-4">
          <div
            className={`${
              window.location.pathname != "/login"
                ? AuthActiveButton
                : AuthInactiveButton
            }`}
          >
            <a href={`${ZEST_API_URL}/login`} target="_blank" rel="noreferrer">
              <Text className={AuthText}>{`${t("auth.existingUser")}, ${t(
                "auth.login"
              )}`}</Text>
            </a>
          </div>
          <div
            className={`${
              window.location.pathname != "/signup"
                ? AuthActiveButton
                : AuthInactiveButton
            }`}
          >
            <a href={`${ZEST_API_URL}/channel/signup`} target="_blank" rel="noreferrer">
              <Text className={AuthText}>{`${t(
                "auth.signUpFor"
              )} ${APP_NAME}`}</Text>
            </a>
          </div>
        </div>
      </Content>
    </Dialog>
  );
};

const Content = tw.div`
md:w-[600px] sm:w-[460px] xsm:w-[350px] w-full 
min:w-[300px]
h-full
md:px-6 px-2
pb-4
md:overflow-x-hidden
sm:overflow-x-hidden
overflow-x-auto
overflow-y-auto
custom-scroll
overflow-auto
bg-white
rounded-lg
`;

const AuthActiveButton = `
px-4
py-1
bg-buttonColor
hover:opacity-80
rounded-full
flex
items-center
justify-center`;

const AuthInactiveButton = `
px-4
py-1
bg-blackText
hover:bg-midGray
rounded-full
flex
items-center
justify-center
hover:cursor-not-allowed`;

const AuthText = `
text-whiteText
text-md
font-normal
font-sans`;

export default AuthenticationModal;
